<script lang="ts">
	import { getTranslate } from "@utils/getTranslate.js";
	import { DateInput } from "date-picker-svelte";
	import { Locale } from "@core/schema/Locale.js";
	import "../../assets/css/date-picker.css";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import translations from "./DatePicker.translations.json" with { type: "json" };
	import { dateInputLocale } from "./dateInputLocale.js";

	const translate = getTranslate(translations);
	const { tenant } = getGlobalTemplateProps();

	let {
		value = $bindable(),
		input = $bindable(),
		/* eslint-disable prefer-const */
		min,
		max,
		excludedDays = [],
		/* eslint-enable prefer-const */
	}: {
		value?: string;
		input?: HTMLInputElement;
		min?: Date;
		max?: Date;
		excludedDays?: number[];
	} = $props();

	function parseDate(string: string | undefined): Date | undefined {
		if (!string || Number.isNaN(Date.parse(string))) {
			return undefined;
		}
		return new Date(`${string}T12:00:00`);
	}

	function formatDate(date: Date | undefined): string | undefined {
		if (!date) {
			return undefined;
		}
		return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
	}

	const format = $derived(tenant.locale === Locale.en ? "MM/dd/yyyy" : "dd. MM. yyyy");
	const isDisabledDate = $derived(
		excludedDays.length > 0 ? (date: Date): boolean => excludedDays.includes(date.getDay()) : null,
	);

	let dateValue = $state(parseDate(value));

	$effect(() => {
		value = formatDate(dateValue);
	});
</script>

<DateInput
	bind:value={dateValue}
	{min}
	{max}
	{isDisabledDate}
	closeOnSelection
	browseWithoutSelecting
	locale={dateInputLocale[tenant.locale]}
	{format}
	placeholder={translate("chooseDate")}
/>
